import { useMutation, useQueryClient } from "react-query";

import axios from "axios";

import { projectServiceEndpoint } from "api/project";

import { SHAPEFILE_TREE_SECTIONS } from "components/project/layers/hooks";
import { useProjectContext } from "components/project/projects/context";
import {
  ORGANIZATION_SHAPEFILES_QUERY_KEYS,
  PROJECT_SHAPEFILES_QUERY_KEYS,
  SHAPEFILE_LIST_QUERY_KEYS
} from "components/project/shapefiles/queries";

import { useShapefileDispatch } from "../../context";

export interface IUseUpdateProjectShapefileFolderColourMutationParams {
  onError?: (error) => void;
  onMutate?: () => void;
  onSettled?: () => void;
  onSuccess?: (data) => void;
}

export type UpdateProjectShapefileFolderColourParamsT = {
  body: {
    key: string;
    value: string;
  };
  shapefileNodeId: string;
  projectId: string;
};

export function UpdateShapefileColors(params: UpdateProjectShapefileFolderColourParamsT) {
  let shapefileNodeId = params.shapefileNodeId;
  if (shapefileNodeId === SHAPEFILE_TREE_SECTIONS.PROJECT) {
    shapefileNodeId = "root";
  }
  const url = `${projectServiceEndpoint}/shapefile/colors/${params.projectId}/${shapefileNodeId}`;
  return axios.put(url, params.body);
}

export function useUpdateProjectShapefileFolderColourMutation({
  onError,
  onMutate,
  onSettled,
  onSuccess
}: IUseUpdateProjectShapefileFolderColourMutationParams) {
  const queryClient = useQueryClient();
  const { selectedProjectId } = useProjectContext();
  const shapefileDisaptch = useShapefileDispatch();
  return useMutation(
    (params: UpdateProjectShapefileFolderColourParamsT) =>
      UpdateShapefileColors({ ...params }),
    {
      onMutate: onMutate && onMutate,
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: [
            PROJECT_SHAPEFILES_QUERY_KEYS.currentProjectShapefiles,
            selectedProjectId
          ]
        });
        queryClient.invalidateQueries({
          queryKey: [
            SHAPEFILE_LIST_QUERY_KEYS.currentProjectShapefileList,
            selectedProjectId
          ]
        });
        queryClient.invalidateQueries({
          queryKey: [ORGANIZATION_SHAPEFILES_QUERY_KEYS.organizationShapefiles]
        });
        shapefileDisaptch({ payload: { isLoadingColors: false } });
        onSuccess && onSuccess(data);
      },
      onError: (error) => {
        shapefileDisaptch({ payload: { isLoadingColors: false } });
        onError && onError(error);
      },
      onSettled: onSettled && onSettled
    }
  );
}
